
/* Myka Home — Smart Product Sort: In Stock → Pre-order (earliest ETA) → Out of Stock */
(function() {
  function parseETA(etaStr) {
    if (!etaStr) return Infinity;
    var match = etaStr.match(/(\d{1,2})\s+(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s+(\d{4})/i);
    if (match) {
      var months = {Jan:0,Feb:1,Mar:2,Apr:3,May:4,Jun:5,Jul:6,Aug:7,Sep:8,Oct:9,Nov:10,Dec:11};
      return new Date(parseInt(match[3]), months[match[2]], parseInt(match[1])).getTime();
    }
    return Infinity;
  }

  function getProductScore(item) {
    var isOos = item.querySelector('.badge--soldout, .sold-out-badge, [data-sold-out], .status-sold-out') !== null;
    var isPre = item.querySelector('.badge--preorder, .pre-order-badge, [data-pre-order]') !== null ||
                (item.textContent && item.textContent.toLowerCase().indexOf('pre-order') > -1 && !isOos);

    if (!isOos && !isPre) return { score: 0, eta: 0 };  // In stock = best
    if (isPre) {
      // Try to find ETA text in the card
      var etaEl = item.querySelector('[data-eta], .delivery-eta, .pre-order-eta');
      var eta = etaEl ? parseETA(etaEl.textContent) : Infinity;
      return { score: 1, eta: eta };  // Pre-order = middle
    }
    return { score: 2, eta: Infinity };  // OOS = last
  }

  function sortProducts() {
    var selectors = [
      '.product-grid',
      '[data-product-grid]',
      '.collection-product-grid',
      '.list-collection-wrapper .halo-row',
      'ul.grid.product-grid',
    ];

    var grid = null;
    for (var i = 0; i < selectors.length; i++) {
      grid = document.querySelector(selectors[i]);
      if (grid) break;
    }
    if (!grid) return;

    var items = Array.from(grid.children).filter(function(el) {
      return el.tagName === 'LI' || el.classList.contains('halo-item') || 
             el.classList.contains('grid__item') || el.getAttribute('data-product-item') !== null;
    });

    if (items.length < 2) return;

    items.sort(function(a, b) {
      var sa = getProductScore(a);
      var sb = getProductScore(b);
      if (sa.score !== sb.score) return sa.score - sb.score;
      if (sa.score === 1) return sa.eta - sb.eta;  // Pre-orders: earliest ETA first
      return 0;
    });

    items.forEach(function(item) { grid.appendChild(item); });
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sortProducts);
  } else {
    sortProducts();
  }

  // Re-run after AJAX pagination/filtering
  document.addEventListener('shopify:section:load', sortProducts);
  
  // Watch for collection filter changes
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      if (m.addedNodes.length > 0) {
        setTimeout(sortProducts, 300);
      }
    });
  });
  
  var productGrid = document.querySelector('#MainContent, .main-content, main');
  if (productGrid) {
    observer.observe(productGrid, { childList: true, subtree: true });
  }
})();


// Myka Home — Dynamic Filter Sidebar v2
// Bypasses Shopify page cache by rendering filters client-side
(function(){
  'use strict';
  
  if (window.location.pathname.indexOf('/collections/') === -1) return;
  if (document.querySelector('.template-product')) return;
  
  var COLLECTION_HANDLE = window.location.pathname.split('/')[2];
  var CURRENT_TAGS = [];
  
  // Parse current tags from URL: /collections/handle/tag1+tag2
  var pathParts = window.location.pathname.split('/');
  if (pathParts.length >= 4 && pathParts[3]) {
    CURRENT_TAGS = decodeURIComponent(pathParts[3]).split('+');
  }
  
  // Filter group definitions
  var FILTER_GROUPS = [
    {
      title: 'Category',
      prefix: 'category:',
      tags: ['lounge-chair','sofa','dining-table','dining-chair','coffee-table','side-table','console-table','tv-unit','bar-stool','bed-frame','bedside-table','buffet-sideboard','desk','office-chair','wardrobe-storage','outdoor-dining','outdoor-lounge','bookcase-shelving','bench','stool','dining-chairs','side-tables','bar-stools','lounge-chairs','coffee-tables','console-tables','desks']
    },
    {
      title: 'Material',
      prefix: 'material:',
      tags: ['timber','fabric','metal','veneer','marble','oak','glass','stone','walnut','rattan','leather','linen','pine','concrete']
    },
    {
      title: 'Colour',
      prefix: 'colour:',
      tags: ['black','natural','brown','grey','white','beige','gold','green','blue','pink']
    },
    {
      title: 'Room',
      prefix: 'room:',
      tags: ['living-room','dining-room','bedroom','home-office','entryway','outdoor','kitchen']
    },
    {
      title: 'Price Range',
      prefix: 'price:',
      tags: ['under-300','under-500','300-500','500-1000','1000-2000','2000-5000','5000-plus']
    }
  ];
  
  function prettify(label) {
    return label.replace(/-/g, ' ').replace(/\b\w/g, function(c){return c.toUpperCase();});
  }
  
  function formatPrice(label) {
    if (label === 'under-300') return 'Under $300';
    if (label === 'under-500') return 'Under $500';
    if (label === '300-500') return '$300 - $500';
    if (label === '500-1000') return '$500 - $1,000';
    if (label === '1000-2000') return '$1,000 - $2,000';
    if (label === '2000-5000') return '$2,000 - $5,000';
    if (label === '5000-plus') return '$5,000+';
    return prettify(label);
  }
  
  // Fetch collection tags via Shopify Collection AJAX API
  var tagUrl = '/collections/' + COLLECTION_HANDLE + '/tags.json';
  // Actually, use the products.json endpoint to get tags
  var productsUrl = '/collections/' + COLLECTION_HANDLE + '/products.json?limit=250';
  
  // Also get page 2+ for larger collections
  var allTags = {};
  var pagesFetched = 0;
  var totalPages = 5; // max pages to fetch
  
  function fetchPage(page) {
    var url = productsUrl + (page > 1 ? '&page=' + page : '');
    return fetch(url).then(function(r){return r.json();}).then(function(data){
      var prods = data.products || [];
      if (prods.length === 0) return [];
      prods.forEach(function(p){
        (p.tags || '').split(', ').forEach(function(t){
          t = t.trim();
          if (t) allTags[t] = (allTags[t] || 0) + 1;
        });
      });
      return prods;
    });
  }
  
  function buildTagUrl(tag, isActive) {
    var tags = CURRENT_TAGS.slice();
    if (isActive) {
      tags = tags.filter(function(t){return t !== tag;});
    } else {
      tags.push(tag);
    }
    if (tags.length === 0) {
      return '/collections/' + COLLECTION_HANDLE;
    }
    return '/collections/' + COLLECTION_HANDLE + '/' + tags.join('+');
  }
  
  function buildFilterHTML() {
    var html = '<div class="myka-filter-form" id="myka-collection-filters">';
    var groupsShown = 0;
    
    FILTER_GROUPS.forEach(function(group, gi) {
      var available = group.tags.filter(function(t) {
        var fullTag = group.prefix + t;
        return allTags.hasOwnProperty(fullTag);
      });
      
      if (available.length === 0) return;
      groupsShown++;
      
      var collapsed = gi >= 2 ? ' collapsed' : '';
      html += '<div class="myka-filter-group' + collapsed + '">';
      html += '<div class="myka-filter-group-title" onclick="this.parentElement.classList.toggle(\'collapsed\')">' + group.title + '</div>';
      html += '<div class="myka-filter-options">';
      
      available.forEach(function(t) {
        var fullTag = group.prefix + t;
        var isActive = CURRENT_TAGS.indexOf(fullTag) !== -1;
        var url = buildTagUrl(fullTag, isActive);
        var label = group.title === 'Price Range' ? formatPrice(t) : prettify(t);
        
        html += '<a href="' + url + '" class="myka-filter-option' + (isActive ? ' active' : '') + '" data-tag="' + fullTag + '">';
        html += '<span class="myka-filter-checkbox"></span>';
        html += '<span>' + label + '</span>';
        if (allTags[fullTag]) {
          html += '<span class="myka-filter-count">' + allTags[fullTag] + '</span>';
        }
        html += '</a>';
      });
      
      html += '</div></div>';
    });
    
    if (CURRENT_TAGS.length > 0) {
      html += '<a href="/collections/' + COLLECTION_HANDLE + '" class="myka-filter-clear">Clear all filters</a>';
    }
    
    html += '</div>';
    
    if (groupsShown === 0) return '';
    return html;
  }
  
  function injectFilters() {
    // Find the sidebar container
    var sidebar = document.querySelector('.halo-sidebar-wrapper');
    if (!sidebar) {
      sidebar = document.querySelector('.sidebar-body');
    }
    if (!sidebar) {
      console.log('[Myka Filters] No sidebar container found');
      return;
    }
    
    var html = buildFilterHTML();
    if (!html) {
      console.log('[Myka Filters] No filter groups available');
      return;
    }
    
    // Remove old mh-filter-sidebar
    var old = document.querySelector('#mh-filter-sidebar, .mh-filter-sidebar');
    if (old) {
      old.innerHTML = '';
      old.style.display = 'none';
      console.log('[Myka Filters] Removed old filter sidebar');
    }
    
    // Remove old filter blocks
    var oldFilters = sidebar.querySelectorAll('.sidebarBlock');
    oldFilters.forEach(function(el){ el.remove(); });
    
    // Remove halo-sidebar-header
    var oldHeader = sidebar.querySelector('.halo-sidebar-header');
    if (oldHeader) oldHeader.remove();
    
    // Insert new filters at the top of sidebar body
    var sidebarBody = sidebar.querySelector('.sidebar-body') || sidebar;
    sidebarBody.innerHTML = html + sidebarBody.innerHTML;
    
    // Update sidebar header title
    var headerTitle = document.querySelector('.halo-sidebar-header .title, .sidebar-header .sidebar-title');
    if (headerTitle) headerTitle.textContent = 'Filter By';
    
    console.log('[Myka Filters] Injected ' + Object.keys(allTags).length + ' tags');
  }
  
  function init() {
    // Fetch all product pages to get complete tag data
    var promises = [];
    for (var p = 1; p <= totalPages; p++) {
      promises.push(fetchPage(p));
    }
    
    Promise.all(promises).then(function(results) {
      var totalProducts = results.reduce(function(s, r){return s + r.length;}, 0);
      console.log('[Myka Filters] Loaded ' + totalProducts + ' products, ' + Object.keys(allTags).length + ' tags');
      injectFilters();
    }).catch(function(err){
      console.error('[Myka Filters] Error:', err);
    });
  }
  
  // Inject CSS
  var style = document.createElement('style');
  style.textContent = '\
.myka-filter-form{margin-bottom:0}\
.myka-filter-group{margin-bottom:20px;padding-bottom:16px;border-bottom:1px solid #e8e0d6}\
.myka-filter-group:last-child{border-bottom:none;margin-bottom:0}\
.myka-filter-group-title{font-size:11px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:#2A2520;margin-bottom:12px;cursor:pointer;display:flex;justify-content:space-between;align-items:center}\
.myka-filter-group-title::after{content:"\\2212";font-size:16px;font-weight:400;color:#8B6F47}\
.myka-filter-group.collapsed .myka-filter-group-title::after{content:"+"}\
.myka-filter-group.collapsed .myka-filter-options{display:none}\
.myka-filter-options{display:flex;flex-direction:column;gap:6px}\
.myka-filter-option{display:flex;align-items:center;gap:8px;cursor:pointer;padding:3px 0;font-size:13px;color:#555;text-decoration:none;transition:color .2s}\
.myka-filter-option:hover{color:#2A2520}\
.myka-filter-option.active{color:#8B6F47;font-weight:600}\
.myka-filter-checkbox{width:16px;height:16px;border:1.5px solid #ccc;border-radius:3px;display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;transition:all .2s}\
.myka-filter-option.active .myka-filter-checkbox{background:#8B6F47;border-color:#8B6F47}\
.myka-filter-option.active .myka-filter-checkbox::after{content:"\\2713";color:#fff;font-size:10px;font-weight:700}\
.myka-filter-count{color:#999;font-size:11px;margin-left:auto}\
.myka-filter-clear{display:inline-block;margin-top:12px;font-size:12px;color:#8B6F47;text-decoration:underline;cursor:pointer}\
.myka-filter-clear:hover{color:#2A2520}\
@media(max-width:768px){.myka-filter-group-title{font-size:13px}}\
';
  document.head.appendChild(style);
  
  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


// === INFINITE SCROLL FIX ===
// The theme.js looks for .pagination-infinite but the HTML has .pagination-page-infinite
// This adds the missing class to make infinite scroll work
(function(){
  function fixInfiniteScroll() {
    var paginationNav = document.querySelector('nav.pagination');
    if (!paginationNav) return;
    
    // Check if it has pagination-page-infinite but not pagination-infinite
    if (paginationNav.classList.contains('pagination-page-infinite') && 
        !paginationNav.classList.contains('pagination-infinite')) {
      paginationNav.classList.add('pagination-infinite');
      console.log('[Myka] Added pagination-infinite class for infinite scroll');
    }
    
    // Also check parent containers
    var infiniteEl = document.querySelector('.pagination-page-infinite');
    if (infiniteEl && !infiniteEl.classList.contains('pagination-infinite')) {
      infiniteEl.classList.add('pagination-infinite');
      console.log('[Myka] Fixed infinite scroll container class');
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixInfiniteScroll);
  } else {
    fixInfiniteScroll();
  }
})();
